export function getLastArticleContainer() {
  const pageContent = document.querySelector(
    '.single .PageMain .PageContainer .PageContent'
  )

  if (!pageContent) {
    return
  }

  const lastArticleContainer = pageContent.lastElementChild
  return lastArticleContainer
}
